import { Typography } from '@mui/material';
import { Button } from 'components/Ui-V3/Button/Button';

type MagicLinkConfirmProps = {
    authenticating: boolean;
    onConfirm: () => void;
    title?: string;
    description?: string;
    buttonLabel?: string;
};

/**
 * Confirmation step shown when a magic-link / invite token is present in the URL.
 *
 * Requiring an explicit click before exchanging the (single-use) token prevents
 * email security scanners — which load links in a headless browser but do not
 * click buttons — from consuming the token before the real user arrives.
 */
export const MagicLinkConfirm = ({
    authenticating,
    onConfirm,
    title = 'Finish signing in',
    description = 'For your security, click below to complete sign-in to Bizly.',
    buttonLabel = 'Continue',
}: MagicLinkConfirmProps) => (
    <>
        <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 500 }}>
            {authenticating ? 'Authenticating...' : title}
        </Typography>
        {!authenticating && (
            <Typography variant="body1" sx={{ mb: 2 }}>
                {description}
            </Typography>
        )}
        <Button
            fullWidth
            autoFocus
            variant="primary"
            shape="square"
            onClick={onConfirm}
            disabled={authenticating}
            aria-label={buttonLabel}
            sx={{ mt: 2 }}
        >
            {authenticating ? 'Authenticating...' : buttonLabel}
        </Button>
    </>
);
